import _ from 'lodash';
import { refApplicationPlatformService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM
} from "./mutations.type";

function getBlankRefApplicationPlatform() {
    return {
        refApplicationPlatformId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        shortName: "",
        name: "",
        notes: "",
        displayOrder: null,
        applicationCount: 0
    };
}

export const refapplicationplatforms = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentRefApplicationPlatform: getBlankRefApplicationPlatform()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                refApplicationPlatformService.getByAccount(accountId)
                    .then(
                        refApplicationPlatforms => {
                            commit(GET_ALL_SUCCESS, refApplicationPlatforms);
                            resolve(refApplicationPlatforms);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, refApplicationPlatformId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return refApplicationPlatformService.getById(refApplicationPlatformId)
                    .then(
                        refApplicationPlatform => {
                            commit(GET_BY_ID_SUCCESS, refApplicationPlatform);
                            resolve(refApplicationPlatform);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, refApplicationPlatform) {
            return refApplicationPlatformService.add(refApplicationPlatform);
        },
        [UPDATE]({ dispatch, commit }, refApplicationPlatform) {
            return refApplicationPlatformService.update(refApplicationPlatform);
        },
        [DELETE]({ dispatch, commit }, refApplicationPlatform) {
            return refApplicationPlatformService.deleteRefApplicationPlatform(refApplicationPlatform);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, refApplicationPlatforms) {
            state.status = { loaded: true };
            state.items = refApplicationPlatforms;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, refApplicationPlatform) {
            state.status = { loaded: true };
            state.currentRefApplicationPlatform = refApplicationPlatform;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentRefApplicationPlatform = getBlankRefApplicationPlatform();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentRefApplicationPlatform = getBlankRefApplicationPlatform();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentRefApplicationPlatform, {
                [field]: value
            });
        },
    }
}
